import { listado } from "./listado";
import { api } from "./backend";

export function crear() {
  return {
    id: 0,
    nombre: "",
    email: "",
    clave: "",
    telefono: "",
    movil: "",
    cargo: "",
    esAdmin: false,
    esPartner: false,
    esRevisor: false,
    bloqueado: false,
  };
}

export function listar(params) {
  return listado("usuarios/listar", params);
}

export function cargar(id) {
  return api.get("usuarios/cargar&id=" + id).then((response) => {
    var data = response.data;

    data.usuario.bloqueado = Boolean(data.usuario.bloqueado);
    data.usuario.esPartner = Boolean(data.usuario.esPartner);
    data.usuario.esAdmin = Boolean(data.usuario.esAdmin);
    data.usuario.esRevisor = Boolean(data.usuario.esRevisor);

    return data;
  });
}

export function cargarPerfilActual(id) {
  return api.get("usuarios/cargarPerfilActual").then((response) => {
    var data = response.data;

    data.usuario.bloqueado = Boolean(data.usuario.bloqueado);
    data.usuario.esPartner = Boolean(data.usuario.esPartner);
    data.usuario.esAdmin = Boolean(data.usuario.esAdmin);
    data.usuario.esRevisor = Boolean(data.usuario.esRevisor);

    return data;
  });
}

export function insertar({ usuario, imagenes, unidadesNegocioResponsable, unidadesNegocioComercial, descuentos }) {
  return api.post("usuarios/insertar", {
    usuario,
    imagenes,
    unidadesNegocioResponsable,
    unidadesNegocioComercial,
    descuentos,
  });
}

export function actualizar({ usuario, imagenes, unidadesNegocioResponsable, unidadesNegocioComercial, descuentos }) {
  return api.post("usuarios/actualizar", {
    usuario,
    imagenes,
    unidadesNegocioResponsable,
    unidadesNegocioComercial,
    descuentos,
  });
}

export function eliminar(id) {
  return api.post("usuarios/eliminar", { id });
}
